import { useAskInputActions } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputProviderShared.js';
import { useLayoutEffect, useState } from 'react';
/**
 * Owns attachment results for one mounted AskInput and shares them with nearby
 * provider consumers.
 *
 * The provider value cannot be derived by those consumers because the upload
 * and paste handlers create AttachmentResults inside AskInput. The provider is
 * only a copy for sibling UI; AskInput keeps using its local state for
 * submission.
 */
export const useAskInputAttachmentState = () => {
    const { setAttachments: publishAttachments } = useAskInputActions();
    const [attachments, setAttachments] = useState();
    // Publish before paint so sibling UI never renders the previous attachment
    // state. useEffect would leave that stale state visible for one paint.
    useLayoutEffect(() => {
        publishAttachments(attachments);
    }, [attachments, publishAttachments]);
    // useLayoutEffect, rather than useEffect, clears the copy before paint. This
    // prevents a sibling from briefly seeing attachments from an AskInput that
    // was removed while its provider stayed mounted.
    useLayoutEffect(() => () => {
        publishAttachments(undefined);
    }, [publishAttachments]);
    return { attachments, setAttachments };
};
//# sourceMappingURL=useAskInputAttachmentState.js.map